__turbopack_context__.v({
  "actions": "HeroSection-module__UKBg_W__actions",
  "content": "HeroSection-module__UKBg_W__content",
  "eyebrow": "HeroSection-module__UKBg_W__eyebrow",
  "hero": "HeroSection-module__UKBg_W__hero",
  "heroGrid": "HeroSection-module__UKBg_W__heroGrid",
  "infoContainer": "HeroSection-module__UKBg_W__infoContainer",
  "infoItem": "HeroSection-module__UKBg_W__infoItem",
  "infoLine": "HeroSection-module__UKBg_W__infoLine",
  "primaryButton": "HeroSection-module__UKBg_W__primaryButton",
  "secondaryButton": "HeroSection-module__UKBg_W__secondaryButton",
  "subtitle": "HeroSection-module__UKBg_W__subtitle",
  "title": "HeroSection-module__UKBg_W__title",
  "visualPanel": "HeroSection-module__UKBg_W__visualPanel",
});
